import { getQuizOverview, getQuizResponse } from 'utils/quizOverview';

export { getQuizResponse } from 'utils/quizOverview';

export const getQuizAnswerText = (answer) => {
    if (answer == null) return '';
    if (Array.isArray(answer)) return answer.map(getQuizAnswerText).filter(Boolean).join('\n');
    if (typeof answer === 'object') return getQuizAnswerText(answer.text ?? answer.answer ?? JSON.stringify(answer));
    return String(answer);
};

export const getQuizAutoGradedScore = (quiz, submission) => {
    const { lmsQuestions, lmsPoints } = getQuizOverview(quiz);
    return {
        possible: lmsPoints,
        earned: lmsQuestions.reduce((total, { id }) => {
            const score = Number(getQuizResponse(submission, id)?.score);
            return total + (Number.isFinite(score) ? score : 0);
        }, 0),
    };
};

export const getCriterionQuestionIds = (quiz, criterionId) =>
    (quiz?.questions ?? []).filter((question) => question.criterion_ids?.includes(criterionId)).map(({ id }) => id);

// A refresh may complete regeneration while a draft save is still in flight.
export const mergeQuizSubmissionRefresh = (current, refreshed, beforeRefresh) => {
    const currentById = new Map((current ?? []).map((submission) => [submission.id, submission]));
    return refreshed.map((submission) => {
        const local = currentById.get(submission.id);
        if (!local) return submission;
        const changedWhileLoading = local !== beforeRefresh.get(submission.id);
        return {
            ...submission,
            ...(changedWhileLoading && {
                grading: local.grading,
                grading_draft: local.grading_draft,
                grade_overrides: local.grade_overrides,
                grade_overrides_draft: local.grade_overrides_draft,
                grading_explanations: local.grading_explanations,
                grading_status: local.grading_status,
                sessions: local.sessions,
            }),
            ...(local.locked && { locked: true }),
        };
    });
};
